import React, { useState, useEffect } from 'react'
import { DatePicker as DatePickerMV } from 'antd-mobile';
import { DatePicker as DatePickerBV } from 'antd';
import { isMobile } from "react-device-detect";
import enUs from 'antd-mobile/lib/date-picker/locale/en_US';
import moment from 'moment';
import CustomPickerLabel from './_CustomPickerLabel'
export const DatePicker = (props) => {
  const [date_value, setDate_value] = useState(null);
  const minDate = moment().subtract(100, 'year').toDate();
  useEffect(() => {
    if (props.value == '') {
      setDate_value(new Date());
    }
    else {
      const dt = new Date(moment(props.value))
      setDate_value(dt);
    }
  }, [props.value]);

  const formatDate = (date) => {
    /* eslint no-confusing-arrow: 0 */
    const pad = n => n < 10 ? `0${n}` : n;
    const dateStr = `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
    return `${dateStr}`;
  }
  return (
    <>
      {
        (isMobile) ?
          (
            <div style={{ borderBottomStyle: 'groove', color: '#978897', fontSize: '14px', fontVariant: 'tabular-nums', marginTop: '-10px' }}>
              <DatePickerMV
                disabled={props.disabled ?? false}
                mode="date"
                format={date => `${formatDate(date)}`}
                title={props.title ?? "Select Date"}
                locale={enUs}
                value={date_value}
                minDate={minDate}
                maxDate={props.maxDate}
                onChange={(value) => {
                  setDate_value(value);
                  if (props.onChange) {
                    props.onChange(value);
                  }
                }}
                onDismiss={() => {
                  setDate_value(null);
                  if (props.onDismiss) {
                    props.onDismiss(null);
                  }
                }}
              >
                <CustomPickerLabel>{props.label}</CustomPickerLabel>
              </DatePickerMV>
            </div>
          ) :
          (
            <DatePickerBV
              disabled={props.disabled ?? false}
              format={'MM/DD/YYYY'}
              value={moment(props.value)}
              style={{ width: '100%' }}
              onChange={(value, dt_str) => {
                setDate_value(value);
                if (props.onChange) {
                  props.onChange(moment(value, 'YYYY-MM-DD'));
                }
              }}
            />
          )
      }
    </>
  )
}
